import {Card} from "../../../basic/card.tsx";
import {MessageCircle} from "lucide-react";
import {Button} from "../../../basic/button.tsx";
import {useTranslationWithKeys} from "../../../../hooks/useTranslationWithKeys";

interface LiveChatSectionProps {
    onStartChat: () => void;
}

export function LiveChatSection({onStartChat}: LiveChatSectionProps) {
    const {t} = useTranslationWithKeys();

    return (
        <Card className="p-8 shadow-sm border-primary/20 bg-gradient-to-br from-primary/5 to-primary/10">
            <div className="flex items-start gap-6">
                <div className="p-4 rounded-full bg-primary/10">
                    <MessageCircle className="h-8 w-8 text-primary"/>
                </div>
                <div className="flex-1">
                    <h2 className="mb-2">{t('support.liveChatSupport')}</h2>
                    <p className="text-muted-foreground mb-6">
                        {t('support.liveChatDescription')}
                    </p>
                    <Button
                        size="lg"
                        onClick={onStartChat}
                    >
                        <MessageCircle className="h-5 w-5 mr-2"/>
                        {t('support.startLiveChat')}
                    </Button>
                </div>
            </div>
        </Card>
    );
}